import React from "react";
import "../assets/css/news.css";
import Navbar from "../components/Navbar";
import { newsItems } from "../components/Data/newsItem";

const NewsPage = () => {
  return (
    <>
      <Navbar />
      <div className="news-page-wrapper">
        <div className="news-header">
          <h1>Latest News</h1>
        </div>

        <div className="news-card-container">
          {newsItems.map((news) => (
            <div key={news.id} className="news-card">
              <img src={news.img} alt={news.title} className="news-image" />
              <div className="news-content">
                <h2 className="news-title">{news.title}</h2>
                <p className="news-date">{news.date}</p>
                <p className="news-summary">{news.summary}</p>
                <button className="read-more-btn">Read More</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NewsPage;
